module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <div style=\"margin: 20px; height: 100px; padding: 10px; border: 1px solid rgb(229, 229, 229); background-color: rgb(255, 255, 255)\">Origin 1px</div> <border style=\"margin: 20px; height: 100px; padding: 10px\">Retina 1px</border> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Border.vue
// module id = 146
// module chunks = 1